import React from 'react';
import { PlaybackComponent } from '../../components/PlaybackComponent';

export default function LiveChannelScene() {
	return <PlaybackComponent />;
}
